/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type PromptType = "chat" | "text";
export const PromptType = {
  Chat: "chat",
  Text: "text",
} as const;
